import { render } from "./YqTableColumn.vue?vue&type=template&id=0524a18e"
import script from "./YqTableColumn.vue?vue&type=script&lang=js"
export * from "./YqTableColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/h5/table/YqTableColumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0524a18e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0524a18e', __exports__)) {
    api.reload('0524a18e', __exports__)
  }
  
  module.hot.accept("./YqTableColumn.vue?vue&type=template&id=0524a18e", () => {
    api.rerender('0524a18e', render)
  })

}


export default __exports__